import { useContext } from 'react';
import TransContext from '~/contexts/TransContext';

export default function LinkRenderer(url='', lang='default') {
  const trans = useContext(TransContext);
  lang = trans?.lang || lang;

  if (/^(mailto|#)|https?:\/\/((?:[\w\d-]+\.)+[\w\d]{2,})/.test(url)) return url;

  const hasSlashStart = url[0] === '/';
  const hasSlashEnd = url[url.length-1] === '/';
  if (!hasSlashStart && url.length > 1) {
    url = '/'+url
  }
  if (!hasSlashEnd && url.length > 1) {
    url = url+'/';
  }

  let localeUrl;
  if (url.includes(`/${lang}/`) || lang === 'default') {
    localeUrl = url;
  } else {
    localeUrl = '/'+lang+(!hasSlashStart ? '/' :'')+url
    localeUrl = localeUrl.replace('//', '/');
  }

  return localeUrl;
}